import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AccountSnackbarsService } from '@qaroni-app/account/services/account-snackbars.service';
import { FileUpload } from '@qaroni-shared/types/file-upload';
import { FileApiObject } from '@qaroni-shared/types/file.response';
import { shareReplay, Subject } from 'rxjs';
import { FilesUploadHttpService } from './files-upload-http.service';

@Injectable({
  providedIn: 'root',
})
export class FilesUploadService {
  private readonly tokenImageSubject = new Subject<FileUpload | null>();

  private http = inject(FilesUploadHttpService);
  private snackbars = inject(AccountSnackbarsService);

  get tokenImage$() {
    return this.tokenImageSubject.asObservable().pipe(shareReplay(1));
  }

  public upload(fileDTO: FormData) {
    this.http
      .upload$(fileDTO)
      .subscribe({ next: this.nextUpload, error: this.errorUpload });
  }

  private nextUpload = (data: FileApiObject): void => {
    if (!data.result.length) {
      return;
    }

    const event = data.result[0];
    this.tokenImageSubject.next(event);
  };

  private errorUpload = (error: HttpErrorResponse): void => {
    this.tokenImageSubject.next(null);

    if (error.status === HttpStatusCode.PayloadTooLarge) {
      this.snackbars.exceededSizeImage();
    }
  };
}
